import React from "react";
import "../App.css";

const Footer = () => {
  return (
    <>
      <div class="w-full bg-black">
        <div class="flex flex-col justify-center items-center lg:py-8 py-6 max-w-screen-xl mx-auto">
          <div
            data-aos="flip-left"
            class="flex flex-wrap gap-4 py-4 px-2 host-grotesk-5 text-white tracking-wide"
          >
            <a href="#home" class="animated-button p-2 lg:!px-4 philosopher-6">
              Home
            </a>
            <a href="#education" class="animated-button p-2 philosopher-6">
              Education
            </a>
            <a href="#experience" class="animated-button p-2 philosopher-6">
              Experience
            </a>
            <a href="#skills" class="animated-button p-2 philosopher-6">
              Skills
            </a>
            <a href="#projects" class="animated-button p-2 philosopher-6">
              Projects
            </a>
            <a href="#services" class="animated-button p-2 philosopher-6">
              Services
            </a>
            <a href="#hobbies" className="animated-button p-2 philosopher-6">
              Hobbies
            </a>
            <a
              href="#testimonials"
              className="animated-button p-2 philosopher-6"
            >
              Testimonials
            </a>
            <a href="#quotes" class="animated-button p-2 philosopher-6">
              Quotes
            </a>
            <a href="#feedback" class="animated-button p-2 philosopher-6">
              Feedback
            </a>
          </div>
          <div class="flex justify-center gap-5">
            {/* <a
              href="https://www.facebook.com/manoj.polawala"
              class="btn2 btn2-fb"
              target="_blank"
              aria-label="Visit our Facebook page"
              title="Visit our Facebook page"
            >
              <svg
                class="w-9 h-9 text-gray-800 fa fa-facebook-f"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  fill-rule="evenodd"
                  d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z"
                  clipRule="evenodd"
                />
              </svg>
            </a> */}

            <a
              href="https://www.instagram.com/jay_kolawala"
              class="btn2 btn2-ig"
              target="_blank"
              aria-label="Visit our Instagram profile"
              title="Visit our Instagram profile"
              rel="noreferrer"
            >
              <svg
                class="w-9 h-9 fa-instagram z-10"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3H8Zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1ZM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-5 3a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
                  clipRule="evenodd"
                />
              </svg>
            </a>

            <a
              href="https://wa.me/+919426631080/?text=Hello"
              target="_blank"
              class="btn2 btn2-wa"
              aria-label="Contact us on WhatsApp"
              title="Contact us on WhatsApp"
              rel="noreferrer"
            >
              <svg
                class="w-9 h-9 text-gray-800 fa-whatsapp"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M12 4a8 8 0 0 0-6.895 12.06l.569.718-.697 2.359 2.32-.648.379.243A8 8 0 1 0 12 4ZM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a9.96 9.96 0 0 1-5.016-1.347l-4.948 1.382 1.426-4.829-.006-.007-.033-.055A9.958 9.958 0 0 1 2 12Z"
                  clipRule="evenodd"
                />
                <path
                  fill="currentColor"
                  d="M16.735 13.492c-.038-.018-1.497-.736-1.756-.83a1.008 1.008 0 0 0-.34-.075c-.196 0-.362.098-.49.291-.146.217-.587.732-.723.886-.018.02-.042.045-.057.045-.013 0-.239-.093-.307-.123-1.564-.68-2.751-2.313-2.914-2.589-.023-.04-.024-.057-.024-.057.005-.021.058-.074.085-.101.08-.079.166-.182.249-.283l.117-.14c.121-.14.175-.25.237-.375l.033-.066a.68.68 0 0 0-.02-.64c-.034-.069-.65-1.555-.715-1.711-.158-.377-.366-.552-.655-.552-.027 0 0 0-.112.005-.137.005-.883.104-1.213.311-.35.22-.94.924-.94 2.16 0 1.112.705 2.162 1.008 2.561l.041.06c1.161 1.695 2.608 2.951 4.074 3.537 1.412.564 2.081.63 2.461.63.16 0 .288-.013.4-.024l.072-.007c.488-.043 1.56-.599 1.804-1.276.192-.534.243-1.117.115-1.329-.088-.144-.239-.216-.43-.308Z"
                />
              </svg>
            </a>
          </div>
          <div class="mt-4 pt-4 border-t border-t-[#ffffff73] w-full flex flex-col gap-2 justify-center items-center">
            {/* <div class="flex gap-4 flex-wrap mb-4 px-2">
              <Link class="animated-button p-2" to="/admin">
                Admin
              </Link>
            </div> */}
            <div class="text-center px-4">
              <span class="text-[#ffffffb2] text-sm">
                Copyright © 2023 | All Rights Reserved | Developed by
              </span>
              <span class="animated-design"> Jay Kolawala</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
